module.exports = __webpack_public_path__ + "static/media/pinned_third_party.a149c63d.svg";